export function filterValidValuesToObject<P extends Object, R>(values: Partial<P>): Partial<R> {
	const map = new Map();

	Object.entries(values).forEach(([key, value]) => {
		if (
			value !== null &&
			value !== undefined &&
			!(Array.isArray(value) && value.length === 0) &&
			!(typeof value === "string" && value === "")
		) {
			map.set(key, value);
		}
	});

	return Object.fromEntries(map);
}
